import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4072EE",
    },
  },
  typography: {
    button: {
      textTransform: "none",
      fontSize: 16,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#FFF",
            backgroundColor: "#4072EE",
            opacity: 0.5,
          },
        },
      },
    },
  },
});

export default theme;
